<div class="mat-app-background">

  <div>
    <app-menu>
    </app-menu>
  </div>

  <div *ngIf="!UserIsEnabled()">
    <div class="user-not-enabled-container">
      {{ 'User.UserNotEnabled' | translate }}
    </div>
  </div>

  <div *ngIf="UserIsEnabled()">
    <app-active-page menuName="Home">
      <app-home></app-home>
    </app-active-page>

    <app-active-page menuName="Collegamento">
      <app-user-login></app-user-login>
    </app-active-page>

    <app-active-page menuName="Cambio Password">
      <app-user-change-password></app-user-change-password>
    </app-active-page>

    <app-active-page menuName="Gestione Utenti">
      <app-gestione-utenti></app-gestione-utenti>
    </app-active-page>

    <app-active-page menuName="Elimina Account">
      <app-delete-account></app-delete-account>
    </app-active-page>

    <app-active-page menuName="Lista Dispositivi">
      <app-devices-list></app-devices-list>
    </app-active-page>

    <app-active-page menuName="Gestione Dispositivi">
      <app-devices-management></app-devices-management>
    </app-active-page>

    <app-active-page menuName="Storico">
      <app-operations-log></app-operations-log>
    </app-active-page>
  </div>

</div>
